// extracted by mini-css-extract-plugin
export default {"cell":"biUJI","contextMenu":"A3asV","ellipsisCell":"kUgHm"};